import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { QMS } from '@vindr/services/apis/qms.api';
import { Typography, Row, Col } from 'antd';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Empty } from '@vindr/ui';

const { Title } = Typography;

interface Widget {
  title: string;
  inprocessItems: number;
  waitItems: number;
  misscallItems: number;
  active: boolean;
}

const QMSBlock = ({ title, inprocessItems, waitItems, misscallItems, active }: Widget) => {
  const { t } = useTranslation('Vindoc');

  return (
    <div
      className={`rounded-s flex h-full w-full min-w-40 cursor-pointer flex-col justify-between p-3 ${
        active ? 'bg-primary-200' : 'bg-primary-dark'
      }`}
    >
      <Title level={4} className="mb-3">
        {title}
      </Title>
      <div className="text-base">
        <div className="mb-2 flex justify-between">
          <div>{t('QMS.In Progress')}</div>
          <div className="ml-2">{inprocessItems}</div>
        </div>
        <div className="mb-2 flex justify-between">
          <div>{t('QMS.Waiting')}</div>
          <div className="ml-2">{waitItems}</div>
        </div>
        <div className="flex justify-between">
          <div>{t('QMS.Miss Call')}</div>
          <div className="ml-2">{misscallItems}</div>
        </div>
      </div>
    </div>
  );
};

const QMSSelect = forwardRef(
  (
    {
      qmsList,
      value,
      onChange,
    }: {
      qmsList: QMS[];
      value?: string;
      onChange?: (qms_id: string, qms: QMS) => unknown;
    },
    ref
  ) => {
    const { t } = useTranslation('Vindoc');
    const filterDevices = qmsList.filter(
      (it) => it.name !== 'All devices' && it.name !== 'Unknown'
    );

    return (
      <div className="flex flex-col w-full justify-between">
        {!filterDevices?.length && <div className="w-full justify-center"><Empty description={t('No available QMS')} /></div>}
        <Row
          gutter={[6, 6]}
          className="grid w-full"
          style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(160px, 1fr))' }}
        >
          {filterDevices.map((it) => (
            <Col key={it?.id + it?.name} className="flex-1">
              <div onClick={() => onChange(it.id, it)} className="h-full">
                <QMSBlock
                  title={it.name}
                  active={it.id === value}
                  inprocessItems={it?.statistic?.in_process || 0}
                  waitItems={it?.statistic?.wait_list || 0}
                  misscallItems={it?.statistic?.miss_call || 0}
                />
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }
);

export default QMSSelect;
